export enum EAppRole {
    Admin = 'Admin',
    ParoMotor = 'ParoMotor',
    User = 'User',
    Developer = 'Developer',
    Conduce = 'Conduce',
    Impulso = 'Impulso',
}

export enum EDocumentRoles {
    Admin = 'documentAdmin',
    ConfidentialView = 'confidentialView'
}
